import React, { useMemo } from 'react';
import CustomizedButton from '@/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button';
import buttonAnimationStyle from '@/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss';
import { twMerge } from 'tailwind-merge';
import { getButtonVariantsData } from '../../Carousel/utils';
import { DownArrowIcon } from '../../CardFrameCollection/components/svg';
import { BUTTON_TYPE } from '@/components/WidgetMaker/utils/buttonConstant';
import { getRoute, PATH } from 'src/utils/routes';
import { useSSRSelector } from 'src/redux';
import { WIDGET_TYPE } from '../constant';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { instaSvg } from './Svgs';
import { ADMIN_WIDGETS } from 'src/constants/widgets';
import { useListPresentationContextData } from '../context/ListPresentationContext';
import CommonLinkWrapper from '../../CommonLinkWrapper';
import { isPLPRequiredSystem } from 'src/utils/isPLPRequiredSystem';

export default function ViewMoreButton() {
  const data = useListPresentationContextData();
  const { listPresentationConfig, cardFrameConfig } = data.state;
  const { getConfigsAndUtils } = data.utilities;
  const { viewAllItemsConfig } = getConfigsAndUtils().generalValues;
  const { setViewAllItemsConfig } = getConfigsAndUtils().setters;
  const isVisible = viewAllItemsConfig.showViewAllButton;
  const {
    widgetContextState: { instaUserData },
  } = useWidgetDndContextData();
  const { store } = useSSRSelector((state) => ({
    store: state.storeReducer.store,
  }));

  const selectedListParent = listPresentationConfig?.contentItems?.listItem?.find((item) => item.isVisible);
  const forFeaturedProducts = listPresentationConfig?.contentItems?.type
    ?.toLocaleLowerCase()
    ?.includes(WIDGET_TYPE.FEATURE);
  const isBlogPage = listPresentationConfig?.type === WIDGET_TYPE.BLOG;
  const isInstaPage = listPresentationConfig?.type === WIDGET_TYPE.INSTAGRAM;
  const isTestimonial = listPresentationConfig?.type === 'testimonials';
  const isProductTestimonial =
    listPresentationConfig?.type === ADMIN_WIDGETS.TESTIMONIALS.type;

  function getRedirectionUrl() {
    if (forFeaturedProducts) {
      const isCategory =
        listPresentationConfig?.contentItems?.type !== WIDGET_TYPE.FEATURED_COLLECTION;
      if (isCategory) {
        return getRoute(
          `${
            isPLPRequiredSystem(store?.theme?.theme_class) ? PATH.SHOP : PATH.PRODUCT
          }?cid=${selectedListParent?.id || 0}`,
          store?.store_info?.domain
        );
      }
      return getRoute(
        PATH.collectionCategories(selectedListParent?.data?.id),
        store?.domain
      );
    }
    return '';
  }

  const viewMoreLinks = useMemo(() => {
    return {
      [WIDGET_TYPE.BLOG]: getRoute(`p/blog`, store?.store_info?.domain),
      [WIDGET_TYPE.INSTAGRAM]: `https://instagram.com/${instaUserData?.user?.username}`,
      [WIDGET_TYPE.TESTIMONIALS]: getRoute('p/testimonial', store?.store_info?.domain),
    };
  }, [instaUserData]);

  if (!isVisible) {
    return null;
  }

  return listPresentationConfig?.viewAllItemsButtonConfig?.map((buttonData, btnIndex) => {
    const buttonVariant = getButtonVariantsData(buttonData);
    const selectedButtonType = buttonVariant[buttonData.type];
    const redirectionLink = forFeaturedProducts
      ? getRedirectionUrl()
      : viewMoreLinks[listPresentationConfig?.type];

    return buttonData.isShow ? (
      <CommonLinkWrapper link={redirectionLink} openLinkInNewTab={isInstaPage}>
        <CustomizedButton
          onClick={(e) => {
            {
              if (!redirectionLink)
                setViewAllItemsConfig((data) => ({
                  ...data,
                  areAllItemsVisible: !data.areAllItemsVisible,
                }));
            }
          }}
          key={btnIndex}
          size={cardFrameConfig?.contentConfig?.textConfig?.textSize}
          btnType={buttonData.type}
          buttonData={buttonData}
          selectedButtonData={selectedButtonType}
          variant={selectedButtonType.variant}
          imageDirection={!isBlogPage ? 'right' : 'left'}
          image={
            !forFeaturedProducts &&
            !isBlogPage &&
            !isInstaPage &&
            !(isTestimonial || isProductTestimonial) && (
              <DownArrowIcon
                arrowColor={buttonData?.btnStyleConfig?.textColor}
                height="18px"
                width="18px"
                className={twMerge(
                  'tw-relative',
                  viewAllItemsConfig?.areAllItemsVisible ? 'tw-rotate-180' : ''
                )}
              />
            )
          }
          className={twMerge(
            'tw-pointer-events-auto !tw-mt-[52px] !tw-max-w-[100%] !tw-whitespace-nowrap !tw-px-[24px] !tw-py-[12px] !tw-text-[14px] !tw-font-normal !tw-leading-[20px]',
            !buttonData?.buttonAnimationConfig?.classKey
              ? '[&_p]:before:!tw-hidden'
              : buttonAnimationStyle[buttonData?.buttonAnimationConfig?.classKey],
            buttonData.type === BUTTON_TYPE.SOLID ? ' !tw-border-none ' : ''
          )}
        >
          <div className="tw-flex tw-items-center tw-gap-[8px]">
            {isInstaPage && (
              <div className="tw-mt-[2px]">
                {instaSvg(buttonData?.btnStyleConfig?.textColor)}
              </div>
            )}
            {forFeaturedProducts || isBlogPage || isTestimonial || isInstaPage
              ? buttonData?.text
              : !viewAllItemsConfig?.areAllItemsVisible
                ? buttonData?.text
                : 'See less'}
          </div>
        </CustomizedButton>
      </CommonLinkWrapper>
    ) : null;
  });
}
